window.createProductCustomiser = function(product_id,product_handle,html_id){
    var ProductCustomiser = {
        canvas: {
            get: null,
            context: null,
            width: null,
            height: null,
            auto_curve: false,
            mask_color: null,
            mask_calculated: null,
            auto_curve_interrupt: 0
        },
        positions: {
            name_x: null,
            name_y: null,
            icon_x: null,
            icon_y: null,
            number_x: null,
            number_y: null,
            max_arc: 359,
          	max_width: 200,
            icon_height: 0,
            icon_width: 0,
        },
        customisation: {
            name: '',
            number: '',
            activeBadges: [],
            badgeNames: [],
            curved: false,
            template_name: null,
            template_number: null,
            hero_or_custom: 'custom',
            font: null,
        },
        font_name: null,
        font_number: null,
        outline_name: null,
        outline_number: null,
        defaultImage: null,
        customFonts: {},
        colorName: null,
        colorOutlineName:  null,
        colorNumber:  null,
        colorOutlineNumber: null,
        construct: function(product_id,product_handle,html_id){
            $.ajax('/products/'+product_handle+'?view=customiser')
            .done(function(response){
                if(response.trim() !== ''){
                  	response = response.replaceAll('@htmlid',html_id).replace('<div id="shopify-section-customisation-inhouse" class="shopify-section">','').slice(0, -6)
                    $('.customisers-inhouse').append(response)
                    this.canvas.get = $('.customisers-inhouse').find('.preview-'+html_id)
                    if(this.canvas.get !== null){
                        this.defaultImage = new Image();
                        this.defaultImage.setAttribute('crossOrigin','anonymous');
                        this.defaultImage.src = this.canvas.get.attr('data-initial');
                        this.badgesObject = JSON.parse($('.customisers-inhouse').attr('data-badges'));
                        this.defaultImage.addEventListener('load', function(){
                            //canvas set up
                            this.canvas.width = this.defaultImage.naturalWidth
                            this.canvas.height = this.defaultImage.naturalHeight
                            this.canvas.get.attr('width',this.canvas.width)
                            this.canvas.get.attr('height',this.canvas.height)
                            this.canvas.context = this.canvas.get[0].getContext("2d")
                            this.canvas.context.imageSmoothingEnabled = true
                            this.canvas.context.imageSmoothingQuality = 'high';

                            //coordinate setup
                            this.positions.name_x = parseInt(this.canvas.get.attr('data-center-name').split(',')[0])
                            this.positions.name_y = parseInt(this.canvas.get.attr('data-center-name').split(',')[1])
                            this.positions.number_x = parseInt(this.canvas.get.attr('data-center-number').split(',')[0])
                            this.positions.number_y = parseInt(this.canvas.get.attr('data-center-number').split(',')[1])

                            this.positions.icon_x = []
                            this.positions.icon_y = []
                            this.positions.icon_width = []
                            this.positions.icon_height = []

                            !!this.badgesObject && $(this.badgesObject.badges).each((index, badge) => {
                                this.positions.icon_x[index] = parseInt(badge.position.split(',')[0])
                                this.positions.icon_y[index] = parseInt(badge.position.split(',')[1])
                                this.positions.icon_width[index] = parseInt(badge.dimensions.split(',')[0])
                                this.positions.icon_height[index] = parseInt(badge.dimensions.split(',')[1])
                            });
                            
                       		this.canvas.mask_color = this.hexToRgb(this.canvas.get.attr('data-mask-color'))
                       
                            this.positions.max_arc = parseInt(this.canvas.get.attr('data-max-arc'))
                            if(this.positions.max_arc > 359){
                                while(this.positions.max_arc > 359){
                                    this.positions.max_arc-=360
                                }
                            }
                          
                          	this.positions.max_width = parseInt(this.canvas.get.attr('data-max-width'))
                            this.canvas.auto_curve = this.canvas.get.attr('data-auto-curve') === 'true' ? true : false

                            this.customisation.curved = this.canvas.get.attr('data-curved') === 'true' ? true : false

                            this.defaultTemplateName = this.canvas.get.attr('data-template-name')
                            this.defaultTemplateNumber = this.canvas.get.attr('data-template-number')
                       		this.customisation.template_name = this.canvas.get.attr('data-template-name')
                            this.customisation.template_number = this.canvas.get.attr('data-template-number');

                            const characterFilter = this.canvas.get.attr('data-character-filter');
                            let regexNamePattern = '';
                            switch(characterFilter){
                                case 'weakest':
                                    regexNamePattern = `[^\\p{L}\\s.\\-\'"]+`;
                                    break;
                                case 'default':
                                    regexNamePattern = `[^A-Za-zÀ-ÖØ-öø-ÿ\\.\\s\\-]+`;
                                    break;
                                case 'strongest':
                                    regexNamePattern = `[^A-Za-z\\.\\s]+`;
                                    break;
                                default:
                                    regexNamePattern = `[^\\p{L}\\s.\\-\'"]+`;
                            }
     
                            this.regexpName = new RegExp(regexNamePattern, 'gu');

                            //init fonts
                            this.initFontSizes();
                            this.initFontColours();
                            this.initDefaultFont();

                            //boot finish
                            this.render()
                            console.log("Init customiser: "+html_id)
                            $("body").trigger( "customiser_init", [html_id]);
                        }.bind(this))
                    }
                    else{
                        console.log("No canvas Found")
                    }
                }
                else{
                    console.log("No Customiser Image Set")
                }
            }.bind(this))
            return this
        },
        initFontSizes() {
            //load in font sizes, based on data attributes and sie of canvas
            this.fontNameSize = (parseFloat(this.canvas.width)/500.0)*parseFloat(this.canvas.get.attr('data-size-name'));
            this.fontNumberSize = (parseFloat(this.canvas.width)/500.0)*parseFloat(this.canvas.get.attr('data-size-number'))
        },
        initFontColours() {
            //load in font colours, based on data attributes
            if(this.canvas.get.attr('data-color-name').includes(',')) {
                this.colorName = this.canvas.get.attr('data-color-name').split(',')[0]
                this.colorOutlineName = this.canvas.get.attr('data-color-name').split(',')[1]
            }
            else {
                this.colorName = this.canvas.get.attr('data-color-name')
            }
            if(this.canvas.get.attr('data-color-number').includes(',')) {
                this.colorNumber = this.canvas.get.attr('data-color-number').split(',')[0]
                this.colorOutlineNumber = this.canvas.get.attr('data-color-number').split(',')[1]
            }
            else {
                this.colorNumber = this.canvas.get.attr('data-color-number')
            }
        },
        initDefaultFont() {
            //name fonts
            const fontNameValue = this.canvas.get.attr('data-font-name')
            if(fontNameValue.includes(',')){
                this.customFonts['init-name'] = window.createTTFFont(fontNameValue.split(',')[0].split('|')[0],fontNameValue.split(',')[0].split('|')[1], this.fontNameSize,this.colorName,this.canvas.context);
                this.font_name = this.customFonts['init-name'];
                this.customFonts['init-outline-name'] = window.createTTFFont(fontNameValue.split(',')[1].split('|')[0],fontNameValue.split(',')[1].split('|')[1], this.fontNameSize,this.colorOutlineName,this.canvas.context)
                this.outline_name = this.customFonts['init-outline-name'];
            }
            else {
                this.customFonts['init-name'] = window.createTTFFont(fontNameValue.split('|')[0],fontNameValue.split('|')[1],this.fontNameSize,this.colorName,this.canvas.context)
                this.font_name = this.customFonts['init-name'];
            }

            //number fonts
            const fontNumberValue = this.canvas.get.attr('data-font-number')
            if(fontNumberValue.includes(',')){
                this.customFonts['init-number'] = window.createTTFFont(fontNumberValue.split(',')[0].split('|')[0],fontNumberValue.split(',')[0].split('|')[1],this.fontNumberSize,this.colorNumber,this.canvas.context);
                this.customFonts['init-outline-number'] = window.createTTFFont(fontNumberValue.split(',')[1].split('|')[0],fontNumberValue.split(',')[1].split('|')[1],this.fontNumberSize,this.colorOutlineNumber,this.canvas.context);
                this.font_number = this.customFonts['init-number'];
                this.outline_number = this.customFonts['init-outline-number'];
            }
            else{
                this.customFonts['init-number'] = window.createTTFFont(fontNumberValue.split('|')[0],fontNumberValue.split('|')[1],this.fontNumberSize,this.colorNumber,this.canvas.context);
                this.font_number = this.customFonts['init-number'];
            }
        },
        drawBadge: function(image, icon_x, icon_y, icon_width, icon_height){
            this.canvas.context.drawImage(image, icon_x-(icon_width/2), icon_y-(icon_height/2), icon_width, icon_height)
        },
		applyMask: function(){
        	if(this.canvas.mask_calculated === null){
              this.canvas.mask_calculated = document.createElement('canvas');
              this.canvas.mask_calculated.width = this.defaultImage.naturalWidth
              this.canvas.mask_calculated.height = this.defaultImage.naturalHeight
              var ctx = this.canvas.mask_calculated.getContext("2d")
              ctx.drawImage(this.defaultImage, 0, 0)
              var imgData = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height)
              var rowWidth = this.defaultImage.naturalWidth*4
              var colorOffset = 10
              for (var row = 0; row < imgData.data.length;row += rowWidth){
                  var mask_start = row+rowWidth-4
                  var mask_end = row
                  for (var i = row; i < row+rowWidth; i += 4) {
                    if (
                        this.canvas.mask_color.r < imgData.data[i]-colorOffset || this.canvas.mask_color.r > imgData.data[i]+colorOffset ||
                        this.canvas.mask_color.g < imgData.data[i+1]-colorOffset || this.canvas.mask_color.g > imgData.data[i+1]+colorOffset ||
                        this.canvas.mask_color.b < imgData.data[i+2]-colorOffset || this.canvas.mask_color.b > imgData.data[i+2]+colorOffset
                    ){
                        mask_start = i
                        break;
                    }
                  }
                  for (var i = row+rowWidth-4; i >= row; i -= 4) {
                    if (
                        this.canvas.mask_color.r < imgData.data[i]-colorOffset || this.canvas.mask_color.r > imgData.data[i]+colorOffset ||
                        this.canvas.mask_color.g < imgData.data[i+1]-colorOffset || this.canvas.mask_color.g > imgData.data[i+1]+colorOffset ||
                        this.canvas.mask_color.b < imgData.data[i+2]-colorOffset || this.canvas.mask_color.b > imgData.data[i+2]+colorOffset
                    ){
                        mask_end = i
                        break;
                    }
                  }
                  for (var i = row; i < row+rowWidth; i += 4) {
                    if (mask_start <= i && mask_end >= i){
                      imgData.data[i+0] = 0
                      imgData.data[i+1] = 0
                      imgData.data[i+2] = 0
                      imgData.data[i+3] = 0
                    }
                  }
              }
              ctx.putImageData(imgData, 0, 0);
			}
			this.canvas.context.drawImage(this.canvas.mask_calculated, 0, 0, this.canvas.width, this.canvas.height)
		},
        hexToRgb: function(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            } : null;
        },
        setName: function(text){
          	const banned = ['bHVs','IGVpa2Vs','IGt1dA==','IGhvZXI=','IGthbmtlcg==','IHRpZWZ1cw==','IHRlcmluZw==','IHNsZXQ=','IHNoaXQ=','IGZ1Y2s=','IHNjaGlqdA==','IGRpa3phaw==','IGRpaw==','IGdlZW5uYWFt','IG5vbmFtZQ==','IGdlZW4gbmFhbQ==','IG5vIG5hbWU=','IGpvb2Q=','IGFtc3RlcmRhbQ==','IGdlZW5uYWFtYXVi','IGdlZW4gbmFhbSBhdWI=','IG5vbmFtZXBscw==','IG5vIG5hbWUgcGxz','IGJsYW5jbw==','IHpvbmRlcm5hYW0=','IHpvbmRlciBuYWFt','IG5hYW0=','IGdlZW4gbGV0dGVycw==','IG5pZXRz','IC8=',]
            const filtered = text.replace(this.regexpName, '');
            if(banned.findIndex(word => { return filtered.toLowerCase().includes(window.atob(word)) }) === -1){
                this.customisation.name = filtered.toUpperCase()
            }
            else{
                this.customisation.name = ''
            }
            const result = this.font_name.autoCurveTest(this.customisation.name,this.positions.max_width,this.customisation.curved,this.canvas.auto_curve)
            this.customisation.name = result[0]
            this.canvas.auto_curve_interrupt = result[1]
            this.render()
        },
        setHeroOrCustom: function(text){
          this.customisation.hero_or_custom = text
        },
        setBadge: function(img_src,name,id,price,varId){
          let badge_image = new Image()
          badge_image.setAttribute('crossOrigin','anonymous')
          badge_image.src = img_src
          let badgeObject = {
            image: badge_image,
            name: name,
            uniqueId: id.trim(),
            price: price,
            id: varId
          }
          this.customisation.activeBadges.push(badgeObject);
          this.customisation.badgeNames.push(name);
          badge_image.addEventListener('load', function(){
          	this.render()
          }.bind(this))
        },
        loadCustomFonts: function(fontArray) {
            // load custom fonts into array
            // the createTTFFont function will create the font and return it, for use later
            if (fontArray && fontArray.length > 0) {
                fontArray.forEach((font) => {
                    const fontKey = font.fontDefault ? 'init' : font.fontValueHandle;
                    if(!this.customFonts[`${fontKey}-name`]) {
                        this.customFonts[`${fontKey}-name`] = window.createTTFFont(`${fontKey}-name`, font.fontName, font.fontNameSize, font.colorName, this.canvas.context);
                    }
                    if(!this.customFonts[`${fontKey}-number`]) {
                        this.customFonts[`${fontKey}-number`] = window.createTTFFont(`${fontKey}-number`, font.fontNumber, font.fontNumberSize, font.colorNumber, this.canvas.context);
                    }
                    if(font.fontNameOutline) {
                        if(!this.customFonts[`${fontKey}-outline-name`]) {
                            this.customFonts[`${fontKey}-outline-name`] = window.createTTFFont(`${fontKey}-outline-name`, font.fontNameOutline, font.fontNameSize, font.colorOutlineName, this.canvas.context);
                        }
                    }
                    if(font.fontNumberOutline) {
                        if(!this.customFonts[`${fontKey}-outline-number`]) {
                            this.customFonts[`${fontKey}-outline-number`] = window.createTTFFont(`${fontKey}-outline-number`, font.fontNumberOutline, font.fontNumberSize, font.colorOutlineNumber, this.canvas.context);
                        }
                    }
                })
            }
        },
        setCustomFont: function(fontValue, fontValueHandle, fontDefault, templateName, templateNumber) {
            this.customisation.font = fontValue;          
            this.outline_name = null;
            this.outline_number = null;
            if(templateName) {
                this.customisation.template_name = templateName;
            }
            if(templateNumber) {
                this.customisation.template_number = templateNumber;
            }

            const fontKey = fontDefault ? 'init' : fontValueHandle;      
            this.font_name =  this.customFonts[`${fontKey}-name`];
            this.font_number = this.customFonts[`${fontKey}-number`];
            if(this.customFonts[`${fontKey}-outline-name`]) {
                this.outline_name = this.customFonts[`${fontKey}-outline-name`];
            }
            if(this.customFonts[`${fontKey}-outline-number`]) {
                this.outline_number = this.customFonts[`${fontKey}-outline-number`];
            }

            this.render();
        },
        setNumber: function(text){
            if (text !== undefined) {
                if(text.length > 2){
                    while(text.length > 2){
                        text = text.slice(1)
                    }
                }
                this.customisation.number = text.trim().replace(/[^0-9]+/g,'')
                if(this.customisation.number !== ''){
                this.customisation.number = ''+Math.abs(parseInt(this.customisation.number))
                }
            }
            this.render()
        },
        reset: function(){
            this.customisation.name = ''
            this.customisation.number = ''
            this.customisation.activeBadges = []
            this.customisation.badgeNames = [],
            this.customisation.font = null
            this.render()
        },
        resetBadge: function(id){
            if(id != null && this.customisation.activeBadges.length > 1){
                $(this.customisation.activeBadges).each((index, activeBadge) => {
                    if(activeBadge.uniqueId == id){
                        this.customisation.activeBadges.splice(index, 1)
                        this.customisation.badgeNames.splice(index, 1)
                        this.render()
                        return;
                    }
                });
            } else {
                this.customisation.activeBadges = []
                this.customisation.badgeNames = []
                this.render()
            }
        },
        toggleCurve: function(){
            this.customisation.curved = !this.customisation.curved
            this.render()
        },
        getCartDetails: function(){
          	var exportImage = document.createElement('canvas')
            var ctx = exportImage.getContext("2d")
            exportImage.height = 150
            exportImage.width = this.canvas.width*(150/this.canvas.height)
            ctx.drawImage(this.canvas.get[0],0,0,exportImage.width-1,exportImage.height-1)
          	var exportVar = {
              main:{
                _name: this.customisation.name,_number: this.customisation.number,_badge_name: this.customisation.badgeNames.toString(),
                _template_name: this.customisation.template_name,
                _template_number: this.customisation.template_number,
                _hero_or_custom: this.customisation.hero_or_custom
              },
              img: exportImage.toDataURL(),
            }
            if(this.customisation.font !== null){
                exportVar.main._font = this.customisation.font
            }
            return exportVar
        },
        render: function(){
            this.canvas.context.drawImage(this.defaultImage, 0, 0)
            if(this.customisation.badge_image !== null){
                if(this.customisation.activeBadges.length > 0){
                    let badgesPrice = 0;
                    $(this.customisation.activeBadges).each((index, activeBadge) => {
                        $(this.badgesObject?.badges).each((index, badge) => {
                            if(badge.uniqueId.trim() == activeBadge.uniqueId){
                                let posX = this.positions.icon_x[index],
                                posY = this.positions.icon_y[index],
                                posW = this.positions.icon_width[index],
                                posH = this.positions.icon_height[index];
    
                                this.drawBadge(activeBadge.image, posX, posY, posW, posH);
                                return;
                            }
                        });
                        badgesPrice += parseInt(activeBadge.price)
                    });

                    if(badgesPrice.toString().length == 3){
                        $('.customisation-'+html_id+'').attr('data-variant-badge-price', `0${badgesPrice}`)
                    } else {
                        $('.customisation-'+html_id+'').attr('data-variant-badge-price', badgesPrice)
                    }
                }
            }
            if(this.font_name !== null && this.customisation.name !== ''){
                if(this.customisation.curved == true || this.canvas.auto_curve_interrupt == 1){
                    var measurement_name = this.font_name.measureText(this.customisation.name)
                    var measurement_number = this.font_number.measureText('00')
                    this.customisation.name = this.font_name.drawTextCurved(
                        this.customisation.name,
                        this.positions.number_x,
                        this.positions.number_y-(measurement_number.actualBoundingBoxAscent/2),
                        this.positions.number_y-this.positions.name_y-(measurement_name.actualBoundingBoxAscent/2),
                        this.positions.max_arc
                    )
                    if(this.outline_name != null){
                        this.outline_name.drawTextCurved(
                            this.customisation.name,
                            this.positions.number_x,
                            this.positions.number_y-(measurement_number.actualBoundingBoxAscent/2),
                            this.positions.number_y-this.positions.name_y-(measurement_name.actualBoundingBoxAscent/2),
                            this.positions.max_arc,
                            this.font_name.largest_char
                        )
                    }
                }
                else{
                    this.font_name.drawText(
                        this.customisation.name,
                        this.positions.name_x,
                        this.positions.name_y
                    )
                    if(this.outline_name != null){
                        this.outline_name.drawText(
                            this.customisation.name,
                            this.positions.name_x,
                            this.positions.name_y
                        )
                    }
                }
            }
            if(this.font_number !== null && this.customisation.number !== ''){
                this.font_number.drawText(
                    this.customisation.number,
                    this.positions.number_x,
                    this.positions.number_y
                )
                if(this.outline_number != null){
                    this.outline_number.drawText(
                        this.customisation.number,
                        this.positions.number_x,
                        this.positions.number_y
                    )
                }
            }
            this.applyMask()
            if (typeof this.onRender === "function") {
                this.onRender()
            }
        }
    }
    return ProductCustomiser.construct(product_id,product_handle,html_id)
}